import LearningResult from './model';
import create from './create';

LearningResult.create = create;

export default LearningResult;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/LearningResult/index.js